import 'css-chunk:src/feature/payment/DuplicateCardConfirmationModal.module.scss';export default {
  "content": "DuplicateCardConfirmationModal_content",
  "message": "DuplicateCardConfirmationModal_message"
};